module.exports = __webpack_public_path__ + "images/dataquest-img2.jpg";